import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import { prismicImage } from 'src/common/utils/prismic-image';
import Price from '../../Price';
import cx from 'classnames';

import './Product.scss';

const Product = ({ minimumAge: minAge, maximumAge: maxAge, ...props }) => (
  <a href={props.link} className="product-item-link">
    <div className={cx('product-item', {
      'product-item-single-product': props.itemsCount === 1
    })}>
      <div
        className="product-item-image">
        <LazyLoad>
          <img src={prismicImage(props.image)} alt={props.image.alt || ''}/>
        </LazyLoad>
      </div>
      <div className={cx('product-item-content', {
        [`product-item-content-items-${props.itemsCount}`]: props.itemsCount
      })}>
        {props.productTitle &&
        ((props.itemsCount === 1 && !props.isDesktop) || (props.isDesktop)) &&
        <h4 className="text-milli product-item-title">{props.productTitle}</h4>
        }
        {props.title &&
        <h4 className="text-base product-item-title">{props.title}</h4>
        }
        {props.cta &&
        <button>{props.cta}</button>
        }
        {props.ageRangeLabel &&
        ((props.isDesktop && props.itemsCount > 1) || (!props.isDesktop && props.itemsCount < 3)) &&
        <span className="age-range text-micro">{replaceTextWithValues(props.ageRangeLabel, { minAge, maxAge })}</span>
        }
        {props.description && props.itemsCount === 1 && props.isDesktop &&
        <div className="text-milli cross-sell-product-description">{props.description}</div>
        }
        {props.price && props.showPrice &&
        <Price price={props.price} savings={props.savings} savingsType="slash"/>
        }
      </div>
    </div>
  </a>
);

Product.propTypes = {
  image: PropTypes.object.isRequired,
  cta: PropTypes.string,
  title: PropTypes.string,
  productTitle: PropTypes.string,
  link: PropTypes.string.isRequired,
  ageRangeLabel: PropTypes.string,
  minimumAge: PropTypes.string,
  maximumAge: PropTypes.string,
  itemsCount: PropTypes.number,
  description: PropTypes.string,
  price: PropTypes.object,
  isDesktop: PropTypes.bool,
  showPrice: PropTypes.bool,
  savings: PropTypes.string
};

export default Product;



// WEBPACK FOOTER //
// ./src/client/js/view/components/RelatedProducts/Product/Product.js